/**
 * 采集相关
 *
 * https://yapi.gaoding.com/project/1536/interface/api/cat_20534
 */

import qs from "qs";
import request from "../utils/request";

/**
 * 添加采集
 * https://yapi.gaoding.com/project/1536/interface/api/117310  认证设计师
 * https://yapi.gaoding.com/project/1536/interface/api/116161  有手机号，非认证设计师
 * https://yapi.gaoding.com/project/1536/interface/api/115501  无手机号
 *
 * @param {{isMuseUser: boolean}} option 是否是原创用户
 * @param {
 *   board_id?: number;
 *   pins: {file_id: number;
 *   text: string;
 *   tags: number[];
 *   aigc?: any
 * }[]} data
 * @returns {Promise<{
 *  status: boolean,
 *  result: Record<number, IPin&{err?: string, msg: string}>
 *  err: string
 *  failMsg: string
 * }>}
 */
export async function createPins({ isMuseUser }, { board_id, pins }) {
  return request({
    method: "post",
    url: isMuseUser ? "/muse/pins" : "/pins/batch",
    data: {
      board_id,
      pins,
    },
  });
}

/**
 * 更新采集
 * https://yapi.gaoding.com/project/1536/interface/api/116219
 * @param pin_id {number}
 * @param board_id {number}
 * @param text {string}
 * @param link {string|undefined}
 * @param tags {number[]}
 * @returns {AxiosPromise}
 */
export function updatePin({ pin_id, board_id, text, link, tags, aigc }) {
  return request({
    method: "put",
    url: `/pins/${pin_id}`,
    data: {
      pin_id,
      board_id,
      text,
      link,
      tags,
      aigc,
    },
  });
}

/**
 * 获取采集详情
 * https://yapi.gaoding.com/project/1536/interface/api/116218
 * @param {
 *   pin_id: number | string;
 *   ignoreMessage?: boolean;
 * }
 * @returns {Promise<{
 *  pin: IPin;
 *  err?: number;
 *  msg?: string;
 * }>}
 */
export function getPin({ pin_id, ignoreMessage, ...query }) {
  return request({
    url: `/pins/${pin_id}`,
    query: {
      fields: "pin:PIN_DETAIL",
      ...query,
    },
    ignoreMessage,
    noParse: true,
  });
}

/**
 * https://yapi.gaoding.com/project/1536/interface/api/115501
 * @param {
 *  board_id: number;
 * file_id: number;
 * text?: string;
 * tags?: string[];
 * via?: number;
 * aigc?: Object;
 * link?: string;
 * media_type?: string;
 * set_cover?:boolean
 * check?: boolean;
 * } data
 * @returns {Promise<IPin>}
 */
export function createPin(data) {
  return request({
    method: "post",
    url: "/pins",
    data,
  });
}
/**
 * 根据图片地址检测是否已抓取为file
 * https://yapi.gaoding.com/project/1536/interface/api/150573
 * @param {{
 *  media: string;
 *  referer?: string;
 * }} param0
 * @returns {Promise<{file_id?: string|number}>}
 */
export function fetchFileByLink({ media, referer }) {
  return request({
    url: "/fetching/file",
    query: {
      media,
      referer,
    },
  });
}

/**
 * https://yapi.gaoding.com/project/1536/interface/api/115713
 * @param pin_id
 * @returns {Promise<*>}
 */
export function deletePin({ pin_id }) {
  return request({
    method: "delete",
    url: `/pins/${pin_id}`,
  });
}

/**
 * https://yapi.gaoding.com/project/1536/interface/api/115713
 * @param {{pin_id:number}[]} pins
 * @returns {Promise<*>}
 */
export function deletePins(pins) {
  return request({
    method: "delete",
    url: `/pins`,
    data: {
      pins,
    },
  });
}

/**
 * 判断采集是否存在画板
 * https://yapi.gaoding.com/project/1536/interface/api/118219
 * @param pin_id
 * @returns {Promise<unknown>}
 */
export function checkPinExisted({ pin_id }) {
  return request({
    url: `/pins/${pin_id}/repin?check=true`,
  });
}

/**
 * 喜欢采集
 * https://yapi.gaoding.com/project/1536/interface/api/116219
 * @param pin_id {number}
 * @returns {AxiosPromise}
 */
export function likePin(pin_id) {
  return request({
    method: "post",
    url: `/pins/${pin_id}/like`,
  });
}

/**
 * 取消喜欢采集
 * https://yapi.gaoding.com/project/1536/interface/api/116219
 * @param pin_id {number}
 * @returns {AxiosPromise}
 */
export function unlikePin(pin_id) {
  return request({
    method: "post",
    url: `/pins/${pin_id}/unlike`,
  });
}

/**
 * 快速采集
 * https://yapi.gaoding.com/project/1536/interface/api/116219
 * @param {{
 *  via?: number;
 *  text?: string;
 *  board_id?: number;
 *  check?: boolean;
 * }} params
 * @returns {AxiosPromise}
 */
export function flashPin({ via, text, board_id, check }) {
  return request({
    method: "post",
    url: "/pins",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    transformRequest: [qs.stringify],
    query: {
      check,
    },
    data: {
      via,
      text,
      board_id,
    },
  });
}
/**
 * 批量添加采集标签
 * @returns {AxiosPromise}
 */
export function batchAddPinTags(data) {
  return request({
    method: "post",
    url: "/pin/tags/",
    data,
  });
}

/**
 * 批量转移采集画板
 * @param {{
 *  pin_id: number,
 *  move_to: number, //目标画板id
 * }[]} pins
 * @returns {AxiosPromise<Record<string, {
 *  moved: boolean
 * }>>}
 */
export function transferPinBoards(pins) {
  return request({
    method: "post",
    url: `/pins/move`,
    data: {
      pins,
    },
  });
}
/**
 * 获取相似采集
 * @returns {AxiosPromise}
 */
export function getSimilarPins({ pin_id, max, limit }) {
  return request({
    url: `/pins/${pin_id}/similar`,
    query: {
      max,
      limit,
    },
  });
}

/**
 * 获取相似采集
 * https://yapi.gaoding.com/project/1536/interface/api/177423
 * @param {{
 *   key: string,
 *   bucket: string,
 *   page: number
 *   limit: number,
 *   rec_type: "pin"|"material",
 *   file_id?: string,
 *   x?: number,
 *   y?: number,
 *   w?: number,
 *   h?: number,
 * }}
 * @returns {Promise<{pins: IPin[], err?: number, msg?: string}>}
 */
export function getFileSimilarPins(query) {
  return request({
    url: "/files/similar",
    query,
  });
}

/**
 * 获取专题下采集
 * @returns {AxiosPromise}
 */
export function getExplorePins({ urlname, max, limit }) {
  return request({
    url: `/explore/${urlname}`,
    query: {
      max,
      limit,
    },
  });
}

/**
 * 获取主题下采集
 * @param {{
 *  filter_ids?:Array<any>;
 *  page:number;
 *  per_page:number;
 *  text?:string;
 *  position?:string;
 *  sort?:string;
 *  fields?:string
 * }}
 * @param {any=} cookie
 * @returns {AxiosPromise}
 */
export function getTopicPins(
  { filter_ids, page, per_page, text, position, sort },
  cookie
) {
  return request({
    url: "/search/scene",
    query: {
      filter_ids,
      page,
      per_page,
      text,
      position,
      sort,
      fields: "pins:PIN|pin_count",
    },
    ...(cookie
      ? {
          headers: {
            cookie,
          },
        }
      : {}),
  });
}

/**
 * 获取采集同在画板
 * @returns {AxiosPromise}
 */
export function getRelatedBoards({ pin_id, max, limit }) {
  return request({
    url: `/pins/${pin_id}/relatedboards`,
    query: {
      max,
      limit,
      fields: "boards:BOARD|more",
    },
  });
}
/**
 * 获取推荐采集
 * @returns {AxiosPromise}
 */
export function getRecommendPins({ pin_id, page, per_page, material }) {
  return request({
    url: `/pins/${pin_id}/recommendweb`,
    query: {
      material,
      page,
      per_page,
      fields: "pins:PIN",
    },
  });
}

/**
 * 获取采集预览
 * @returns {AxiosPromise}
 */
export function getPreviewPins({ pin_id, board_id, limit, max, since }) {
  return request({
    url: `/boards/${board_id}/raw_pins`,
    query: {
      pin_id,
      limit,
      max,
      since,
    },
  });
}

/**
 * 获取第三方站点采集
 * @returns {AxiosPromise}
 */
export function getFromPins({ urlname, limit, max, since }) {
  return request({
    url: `/from/${urlname}`,
    query: {
      limit,
      max,
      since,
    },
  });
}

/**
 * 获取偏好采集
 * @returns {AxiosPromise}
 */
export function getFavoritePins({ urlname, limit, max, since }) {
  return request({
    url: `/favorite/${urlname}`,
    query: {
      limit,
      max,
      since,
    },
  });
}

/**
 * 屏蔽采集
 * @returns {AxiosPromise}
 */
export function shieldPin(data) {
  return request({
    method: "post",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 取消屏蔽采集
 * @returns {AxiosPromise}
 */
export function cancelShieldPin(data) {
  return request({
    method: "delete",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 获取套系的采集列表
 * @returns {AxiosPromise}
 */
export function getSeries({ group_ids }) {
  return request({
    url: "/materials/groups/pins",
    query: {
      group_ids,
    },
  });
}

/**
 * 采集图片文件申诉
 * @param {number} pin_id
 * @returns
 */
export function fileAppeal(pin_id) {
  return request({
    url: `/pins/${pin_id}/appeal`,
    method: "post",
  });
}
